export default __webpack_public_path__ + "static/media/keto_constipation@2x.6baec16c.jpg";